import React from 'react';

function TextArea({
  id,
  required = false,
  placeholder,
  className = 'form-control',
  type,
  label,
  rows = '3',
  ...restProps
}) {
  return (
    <>
      <label htmlFor={id}>
        {label}
        {required ? <span className="requred">*</span> : ''}
      </label>
      <textarea
        type={type}
        className={className}
        id={id}
        placeholder={placeholder}
        required={required}
        rows={rows}
        {...restProps}
      />
    </>
  );
}

export default TextArea;
